import { getEnv } from "./utils"

export function getApps() {
  const env = getEnv()

  return [
    { 
      path: 'eventPortal',
      name: 'Event Portal', 
      url: `https://events.${env}.prosolve.com`, 
      jobsUrl: `https://events.${env}.prosolve.com/jobs/noheader` 
    },
    { 
      path: 'starEventPortal',
      name: 'Star Event Portal', 
      url: `https://star.events.${env}.prosolve.com`, 
      jobsUrl: `https://star.events.${env}.prosolve.com/jobs/noheader` 
    }
  ]
}
